export const KOREA_WIDE_AREA: { [key: string]: string } = {
  서울특별시: "서울 전체",
  부산광역시: "부산 전체",
  대구광역시: "대구 전체",
  인천광역시: "인천 전체",
  광주광역시: "광주 전체",
  대전광역시: "대전 전체",
  울산광역시: "울산 전체",
  세종특별자치시: "세종 전체",
  경기도: "경기 전체",
  강원도: "강원 전체",
  충청북도: "충북 전체",
  충청남도: "충남 전체",
  전라북도: "전북 전체",
  전라남도: "전남 전체",
  경상북도: "경북 전체",
  경상남도: "경남 전체",
  제주도: "제주 전체",
};

export const KOREA_AREA = {
  서울: [
    "서울 전체",
    "서울 강남구",
    "서울 강동구",
    "서울 강북구",
    "서울 강서구",
    "서울 관악구",
    "서울 광진구",
    "서울 구로구",
    "서울 금천구",
    "서울 노원구",
    "서울 도봉구",
    "서울 동대문구",
    "서울 동작구",
    "서울 마포구",
    "서울 서대문구",
    "서울 서초구",
    "서울 성동구",
    "서울 성북구",
    "서울 송파구",
    "서울 양천구",
    "서울 영등포구",
    "서울 용산구",
    "서울 은평구",
    "서울 종로구",
    "서울 중구",
    "서울 중랑구",
  ],
  부산: [
    "부산 전체",
    "부산 강서구",
    "부산 금정구",
    "부산 기장군",
    "부산 남구",
    "부산 동구",
    "부산 동래구",
    "부산 부산진구",
    "부산 북구",
    "부산 사상구",
    "부산 사하구",
    "부산 서구",
    "부산 수영구",
    "부산 연제구",
    "부산 영도구",
    "부산 중구",
    "부산 해운대구",
  ],
  대구: ["대구 전체", "대구 남구", "대구 달서구", "대구 달성군", "대구 동구", "대구 북구", "대구 서구", "대구 중구"],
  인천: [
    "인천 전체",
    "인천 강화군",
    "인천 계양구",
    "인천 남동구",
    "인천 동구",
    "인천 미추홀구",
    "인천 부평구",
    "인천 서구",
    "인천 연수구",
    "인천 옹진군",
    "인천 중구",
  ],
  광주: ["광주 전체", "광주 광산구", "광주 남구", "광주 동구", "광주 북구", "광주 서구"],
  울산: ["울산 전체", "울산 남구", "울산 동구", "울산 북구", "울산 울주군", "울산 중구"],
  대전: ["대전 전체", "대전 대덕구", "대전 동구", "대전 서구", "대전 유성구", "대전 중구"],
  세종: ["세종 전체", "세종 세종시"],
  경기: [
    "경기 전체",
    "경기 가평군",
    "경기 고양시 덕양구",
    "경기 고양시 일산동구",
    "경기 고양시 일산서구",
    "경기 과천시",
    "경기 광명시",
    "경기 광주시",
    "경기 구리시",
    "경기 군포시",
    "경기 김포시",
    "경기 남양주시",
    "경기 동주천시",
    "경기 부천시",
    "경기 성남시 분당구",
    "경기 성남시 수정구",
    "경기 성남시 중원구",
    "경기 수원시 권선구",
    "경기 수원시 영통구",
    "경기 수원시 장안구",
    "경기 수원시 팔달구",
    "경기 시흥시",
    "경기 안성시",
    "경기 안산시 단원구",
    "경기 안산시 상록구",
    "경기 안양시 동안구",
    "경기 안양시 만안구",
    "경기 양주시",
    "경기 양평군",
    "경기 여주시",
    "경기 연천군",
    "경기 오산시",
    "경기 용인시 기흥구",
    "경기 용인시 수지구",
    "경기 용인시 처인구",
    "경기 의왕시",
    "경기 의정부시",
    "경기 이천시",
    "경기 파주시",
    "경기 평택시",
    "경기 포천시",
    "경기 하남시",
    "경기 화성시",
  ],
  강원: [
    "강원 전체",
    "강원 강릉시",
    "강원 고성군",
    "강원 동해시",
    "강원 삼척시",
    "강원 속초시",
    "강원 양구군",
    "강원 양양군",
    "강원 영월군",
    "강원 원주시",
    "강원 인제군",
    "강원 정선군",
    "강원 철원군",
    "강원 춘천시",
    "강원 태백시",
    "강원 평창군",
    "강원 홍천군",
    "강원 화천군",
    "강원 횡성군",
  ],
  충북: [
    "충북 전체",
    "충북 괴산군",
    "충북 단양군",
    "충북 보은군",
    "충북 영동군",
    "충북 옥천군",
    "충북 음성군",
    "충북 제천시",
    "충북 증평군",
    "충북 진천군",
    "충북 청주시 상당구",
    "충북 청주시 서원구",
    "충북 청주시 청원군",
    "충북 청주시 흥덕구",
    "충북 충주시",
  ],
  충남: [
    "충남 전체",
    "충남 계룡시",
    "충남 공주시",
    "충남 금산군",
    "충남 논산시",
    "충남 당진시",
    "충남 보령시",
    "충남 부여군",
    "충남 서산시",
    "충남 서천군",
    "충남 아산시",
    "충남 예산군",
    "충남 천안시 동남구",
    "충남 천안시 서북구",
    "충남 청양군",
    "충남 태안군",
    "충남 홍성군",
  ],
  경북: [
    "경북 전체",
    "경북 경산시",
    "경북 경주시",
    "경북 고령군",
    "경북 구미시",
    "경북 군위군",
    "경북 김천시",
    "경북 문경시",
    "경북 봉화군",
    "경북 상주시",
    "경북 성주군",
    "경북 안동시",
    "경북 영덕군",
    "경북 영양군",
    "경북 영주시",
    "경북 영천시",
    "경북 예천군",
    "경북 울릉군",
    "경북 울진군",
    "경북 의성군",
    "경북 청도군",
    "경북 청송군",
    "경북 칠곡군",
    "경북 포항시 남구",
    "경북 포항시 북구",
  ],
  경남: [
    "경남 전체",
    "경남 거제시",
    "경남 거창군",
    "경남 고성군",
    "경남 김해시",
    "경남 남해군",
    "경남 밀양시",
    "경남 사천시",
    "경남 산청군",
    "경남 양산시",
    "경남 의령군",
    "경남 진주시",
    "경남 창녕군",
    "경남 창원시 마산합포구",
    "경남 창원시 마산회원구",
    "경남 창원시 성산구",
    "경남 창원시 의창구",
    "경남 창원시 진해구",
    "경남 통영시",
    "경남 하동군",
    "경남 함안군",
    "경남 함양군",
    "경남 합천군",
  ],
  전북: [
    "전북 전체",
    "전북 고창군",
    "전북 군산시",
    "전북 김제시",
    "전북 남원시",
    "전북 무주군",
    "전북 부안군",
    "전북 순창군",
    "전북 완주군",
    "전북 익산시",
    "전북 임실군",
    "전북 장수군",
    "전북 전주시 덕진구",
    "전북 전주시 완산구",
    "전북 정읍시",
    "전북 진안군",
  ],
  전남: [
    "전남 전체",
    "전남 강진군",
    "전남 고흥군",
    "전남 곡성군",
    "전남 광양시",
    "전남 구례군",
    "전남 나주시",
    "전남 담양군",
    "전남 목포시",
    "전남 무안군",
    "전남 보성군",
    "전남 순천시",
    "전남 신안군",
    "전남 여수시",
    "전남 영광군",
    "전남 영암군",
    "전남 완도군",
    "전남 장성군",
    "전남 장흥군",
    "전남 진도군",
    "전남 함평군",
    "전남 해남군",
    "전남 화순군",
  ],
  제주: ["제주 전체", "제주 서귀포시", "제주 제주시"],
};
